/** What every in-place profile editor needs from the page. */
export interface ProfileEditorModalProps {
  isOpen: boolean;
  onClose: () => void;
  isSaving: boolean;
  error: string | null;
}

/** One key per editable profile section. */
export enum ProfileFormModalName {
  AboutMe = 'aboutMe',
  SocialLinks = 'socialLinks',
  Photos = 'photos',
  PlayingLevel = 'playingLevel',
  PreferredTime = 'preferredTime',
  PreferredCourts = 'preferredCourts',
  Verification = 'verification',
}
